// extracted by mini-css-extract-plugin
module.exports = {"text":"m8YFFaQK","textProfit":"Y5tOzhO8","rect":"TpAPOMhz","rectProfit":"w5bSQH7t"};